import React from 'react';
import { Lightbulb, FlaskConical, Box, Percent, Rocket } from 'lucide-react';
import MetricCard from '../MetricCard';

interface IdeaStatsProps {
  totalIdeas: number;
  emAvaliacao: number;
  emPesquisa: number;
  mvp: number;
  lancadas?: number;
  arquivadas?: number;
}

export default function IdeaStats({ totalIdeas, emAvaliacao, emPesquisa, mvp, lancadas = 8 }: IdeaStatsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <MetricCard
        title="Total de Ideias"
        value={totalIdeas.toString()}
        trend="+12 novas"
        trendUp={true}
        contextText="ideias no workspace"
        icon={Lightbulb}
        color="text-amber-600"
        bg="bg-amber-50/80"
        secondaryLabel="Funil"
        secondaryValue="75%"
        progress={75}
        progressColor="bg-amber-500"
      />
      <MetricCard
        title="Em Análise & Pesquisa"
        value={(emAvaliacao + emPesquisa).toString()}
        trend="Em progresso"
        trendUp={true}
        contextText="análise de viabilidade"
        icon={FlaskConical}
        color="text-indigo-600"
        bg="bg-indigo-50/80"
        secondaryLabel="Velocidade"
        secondaryValue="60%"
        progress={60}
        progressColor="bg-indigo-600"
      />
      <MetricCard
        title="MVP Planejado"
        value={mvp.toString()}
        trend="+2 prontas"
        trendUp={true}
        contextText="prontas para protótipo"
        icon={Box}
        color="text-emerald-600"
        bg="bg-emerald-50/80"
        secondaryLabel="Prontidão"
        secondaryValue="80%"
        progress={80}
        progressColor="bg-emerald-500"
      />
      <MetricCard
        title="Taxa de Aprovação"
        value="24%"
        trend="Critério Alto"
        trendUp={false}
        contextText="promovidas ao roadmap"
        icon={Percent}
        color="text-blue-600"
        bg="bg-blue-50/80"
        secondaryLabel="Qualificação"
        secondaryValue="24%"
        progress={24}
        progressColor="bg-blue-600"
      />
      <MetricCard
        title="Promovidas a Projeto"
        value={lancadas.toString()}
        trend="Convertidas"
        trendUp={true}
        contextText="convertidas em projetos"
        icon={Rocket}
        color="text-purple-600"
        bg="bg-purple-50/80"
        secondaryLabel="Taxa de Sucesso"
        secondaryValue="85%"
        progress={85}
        progressColor="bg-purple-600"
      />
    </div>
  );
}
